import { validateCardExpiry } from '../card';
export const cardExpiryValidatorKey = 'cardExpiry';
export const cardExpiryValidator = (value) => ({
    [cardExpiryValidatorKey]: validateCardExpiry(value),
});
//# sourceMappingURL=card-expiry.validator.js.map